<template>
    <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar color="kbBlue" dark>
                <span class="text-h6">{{ $t('general.changePassword') }}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form v-model="valid" ref="formChangePassword" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="currentPassword"
                                          color="kbDarkBlue"
                                          :label="$t('general.actualPassword')"
                                          type="password"
                                          :rules="[rules.required, rules.min8]">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field v-model="newPassword"
                                          color="kbDarkBlue"
                                          :label="$t('login.newPassword')"
                                          type="password"
                                          :rules="[rules.required, rules.min8]">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-text-field v-model="repeatPassword"
                                          color="kbDarkBlue"
                                          :label="$t('login.confirmNewPassword')"
                                          type="password"
                                          :rules="[rules.required, rules.min8]">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-2"
                       color="red"
                       outlined
                       @click="toggleModal(false)">
                    {{ $t('general.cancel') }}
                </v-btn>
                <v-btn color="kbBlue"
                       dark
                       @click="submit()"
                       :loading="loading">
                    {{ $t('general.change') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
import usersService from '@/services/usersService'
export default {
  data () {
    return {
      currentPassword: '',
      newPassword: '',
      repeatPassword: '',
      loading: false,
      valid: false,
      rules: rules
    }
  },
  methods: {
    submit () {
      if (!this.$refs.formChangePassword.validate()) return
      if (this.newPassword !== this.repeatPassword) return notifications.error(this.$t('rules.passwordsDontMatch'))
      this.loading = true
      usersService.changePassword(this.$store.getters.token, this.currentPassword, this.newPassword).then(() => {
        this.toggleModal(false)
        notifications.success(this.$t('login.passwordSuccessfullyChanged'))
        this.loading = false
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    toggleModal (value) {
      this.$refs.formChangePassword.reset()
      this.$emit('input', value)
    }
  },
  props: ['value']
}
</script>
